import React from 'react';
import PropTypes from 'prop-types';
import InteractiveNotification from './InteractiveNotification';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Cookies from 'js-cookie';

export default class InteractiveNotifications extends React.Component {
  static propTypes = {
    animate: PropTypes.bool,
    cookieExpiresInDays: PropTypes.number,
    dataAttribute: PropTypes.string,
    nameOfCookie: PropTypes.string,
    notification: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
        body: PropTypes.string.isRequired,
      })
    ),
    reloadOnClose: PropTypes.bool,
    suppressNotification: PropTypes.bool,
  };

  static defaultProps = {
    animate: true,
    cookieExpiresInDays: 365,
    dataAttribute: 'notification-banner',
  };

  constructor(props) {
    super(props);
    this.state = {
      showNotification: false,
    };
  }

  async componentDidMount() {
    this.getCookie();
  }

  setCookie = () => {
    Cookies.set(this.props.nameOfCookie, 'true', { expires: this.props.cookieExpiresInDays });
    this.setState({ showNotification: false });
    if (this.props.reloadOnClose) {
      location.reload();
    }
  };
  getCookie = () => {
    const cookie = Cookies.get(this.props.nameOfCookie);
    if (!cookie) {
      this.setState({ showNotification: true });
    }
  };

  render() {
    const { notification, animate, dataAttribute, suppressNotification } = this.props;
    const transitionTimeout = animate ? 1000 : 0;
    return (
      <>
        {!suppressNotification && (
          <div data-attribute={dataAttribute} className="system-notifications interactive-notification">
            <TransitionGroup className="system-transition-group">
              <CSSTransition classNames="notification" timeout={transitionTimeout} key={notification.id}>
                <InteractiveNotification
                  {...notification}
                  setCookie={this.setCookie}
                  show={this.state.showNotification}
                />
              </CSSTransition>
            </TransitionGroup>
          </div>
        )}
      </>
    );
  }
}
